var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: { title: _vm.$t("home.saveTip"), isShowFollow: false },
              on: { open: _vm.opened },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c("div", { staticStyle: { margin: "20px 20px 0" } }, [
              _c(
                "div",
                {
                  staticClass: "table-container-new",
                  staticStyle: { "margin-top": "10px" },
                },
                [
                  _c("div", [
                    _c(
                      "h4",
                      { staticStyle: { "font-size": "17px", color: "red" } },
                      [_vm._v(_vm._s(_vm.$t(this.notice)))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.tableData,
                        "header-cell-style": { borderColor: "white" },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: _vm.$t("No"),
                          width: "40",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("home.vesselCode"),
                          "min-width": "6%",
                          prop: "vesselCode",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("home.voyageNo"),
                          "min-width": "6%",
                          prop: "voyageNo",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("home.voyageLeg"),
                          "min-width": "6%",
                          prop: "voyageLeg",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("home.containerNo"),
                          "min-width": "9%",
                          "show-overflow-tooltip": "",
                          prop: "containerNo",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("home.blNo"),
                          "min-width": "9%",
                          prop: "blNo",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("home.bkNo"),
                          "min-width": "10%",
                          prop: "bkNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "text-align": "right" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        "text-align": "center",
                        margin: "20px 0",
                        width: "100px",
                      },
                      attrs: { type: "primary" },
                      on: { click: _vm.handleClose },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("home.buttonClose")) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }